import PropTypes from 'prop-types';
import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  borderRadius:'18px',
  bgcolor: 'background.paper',
  p: 4,
};

export default function TransitionsModal({children, open, handleClose}) {

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 1200,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
           {children}
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

TransitionsModal.propTypes = {
  children: PropTypes.any,
  handleClose: PropTypes.any,
  open: PropTypes.any
};